module.exports = __webpack_public_path__ + "img/DSC_0824.a944e85c.jpeg";